<template>
	<BaseModal
		:show="isOpen"
		:rounded="whitelabel?.styles?.bg?.borderRadius"
		:class="partnerClass"
		class="relative z-10"
		@close="onClose"
	>
		<template #title>
			<div class="mt-4 text-left text-xl font-semibold text-gray-900">
				Before you begin
			</div>
		</template>

		<template #content>
			<div class="text-md mt-5 space-y-5">
				<div>
					Carbar's subscription application will take
					<span class="font-semibold text-gray-700">
						5-10 minutes.
					</span>
				</div>
				<div>
					Have the following documents ready to speed things up.
				</div>

				<div class="text-md">
					<div class="font-semibold text-gray-700">
						Documents required
					</div>
					<div class=" ">
						- Driver licence (Australian or international)
					</div>
					<div class=" ">- Medicare card or passport</div>
					<div class=" ">
						- 3 months bank statements/online banking details
					</div>
				</div>

				<hr />

				<div class="flex flex-row items-center gap-2">
					<div class="block">
						<IconExclamation class="text-gray-500" />
					</div>
					<div class="text-sm">
						All drivers must be 21 years or older and hold a P2 or
						higher drivers license.
					</div>
				</div>
			</div>

			<div v-if="userLoggedIn" class="mt-5 text-center">
				<div class="mt-5 text-center">
					<CarbarButton
						:disabled="startingOrderState.isDisabled"
						:show-loader="startingOrderState.showLoader"
						:rounded="whitelabel?.styles?.button?.borderRadius"
						:background-color="whitelabel?.styles?.button?.bg"
						min-width="min-w-full"
						@click="onContinue"
					>
						{{ startingOrderState.label }}
					</CarbarButton>
				</div>
			</div>
			<div v-else class="mt-5 text-center">
				<CarbarButton
					:rounded="whitelabel?.styles?.button?.borderRadius"
					:background-color="whitelabel?.styles?.button?.bg"
					min-width="min-w-full"
					@click="continueWithAuth('login')"
				>
					Sign in to subscribe
				</CarbarButton>

				<p class="mt-4 text-base">
					New Customer?
					<CarbarLink
						text="Sign up now"
						text-color="text-gray-700"
						font-size="text-base"
						:hover-color="whitelabel?.styles?.button?.hover"
						:underline-color="whitelabel?.styles?.button?.underline"
						:pointer="true"
						@click="continueWithAuth('signup')"
					/>
				</p>
			</div>
		</template>
	</BaseModal>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import BaseModal from '@/components/modals/BaseModal.vue'
import IconExclamation from '@/assets/svg/product-details/ico-exclamation.svg'
const props = defineProps({
	isOpen: {
		type: Boolean,
		required: true,
	},
	isVehicleAvailable: {
		type: Boolean,
		default: true,
	},
	isStartingOrder: {
		type: Boolean,
		default: false,
	},
})

const { whitelabel } = useWhitelabelsStyles()
const { partnerName } = useGetPartnerName()

const partnerClass = computed(() => {
	return partnerName.value === 'carsales' ? 'carsales' : ''
})

const route = useRoute()

const emit = defineEmits(['close', 'startNewOrder'])

const userLoggedIn = computed(() => isLoggedIn())

const startingOrderState = computed(() => ({
	isDisabled: !props.isVehicleAvailable || props.isStartingOrder,
	showLoader: props.isVehicleAvailable && props.isStartingOrder,
	label: props.isVehicleAvailable
		? 'Get started'
		: 'Vehicle is currently unavailable',
}))

const continueWithAuth = (destination) => {
	const redirect = btoa(route.path + '#subscribe-now')
	const isLogin = destination === 'login'
	const getRedirectUrl = (url) => `${url}?_redirect=${redirect}`

	const isWhitelabel =
		props.whitelabel && Object.keys(props.whitelabel).length > 0

	const destinationUrl = () => {
		if (isWhitelabel) {
			const url = isLogin
				? props.whitelabel?.links?.signInUrl
				: props.whitelabel?.links?.signUpUrl
			return getRedirectUrl(url)
		} else {
			const defaultUrl = isLogin ? '/secure/login' : '/sign-up'
			return getRedirectUrl(defaultUrl)
		}
	}

	storeUserRedirect(redirect)

	navigateTo(destinationUrl())
}

function onClose() {
	emit('close')
}
function onContinue() {
	emit('startNewOrder')
}
</script>
